/*
In your main file "index.js" put this line:
import './config';

Everywhere you need your object use this:
global.config.companyInfo
*/
// import 'entities.js';


module.exports.global = global.config = {
    websiteInfo: {
        language: "nl"
        ,creationDate: "2025"
    }
    //global.config.companyInfo
    ,companyInfo: {
        name: "Klassieke Homeopathie Praktijk"
        ,abbreviation: ""
        ,establishedDate: new Date(1999, 1, 1)
        ,description: ""
        ,owner: "Anita Schuit"
        ,ownerImage: '/images/company/anita.jpeg'

        // -
        ,nvkh: "01-0935"
        ,rbcz: "170401R"
        ,agb: "90(0)02745/90023889"
        ,kvk: "01110468"
        ,btw: "NL001119172B05"

        ,businessHours: {
            maandag: ["7:30", "16:30"]
            ,dinsdag: ["7:30", "16:30"]
            ,woensdag: ["7:30", "16:30"]
            ,donderdag: ["7:30", "16:30"]
            ,vrijdag: ["7:30", "14:30"]
        }

        // Location
        ,country: "Nederland"
        ,address: {
            whole: "Lauwers 9" + ", " + "9405BL Assen"
            ,street: "Lauwers"
            ,number: "9"
            ,city: "Assen"
            ,stateProvince: "Drenthe"
            ,zipCode: "9405BL"
        }
        
        // Email's
        ,emailMain: "ageschuit@gmail.com"
        ,emailExample: "email.example@example.com"
        ,emails: {
            offerte: "email.example@example.com"
        }

        // Phone numbers
        ,phoneNumberMain: "(+31) 6 36 20 27 65"
        ,phoneNumberClean: "+31636202765"
        ,phoneNumbers: {
            phoneNumber01: "(+31) 5 55 55 55 555"
        }
    }
    ,companyMedia: {
        logo: "/logo/logo_KHH_big.png"
        ,logoWhite: "/logo/logo_KHH_small.png"
    }
    ,authorInfo: {
        name: "Peter Schreuder"
        ,emailMain: ""
        ,phoneNumberMain: ""
        ,website: ""
    }
	,placeholder: {
		image: "/images/placeholder/placeholder.jpg"
	}
}



/*

,variable: ""

*/